/*========================================================================
* $Id: summarize.js 97320 2017-04-07 11:14:01Z michael.biebl $
*
* Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2013
*
* Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
* Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
* Urheber festgelegten Stelle in der Funktion des Computerprogramms
* angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
* Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
* Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
* =========================================================================*/

define([
  "client/template",
  "client/templates",
  "client/templateregistry",
  "component!base",
  "!!raw-loader!../mustache/template.mustache",
  "underscore",
  "api/v2/api",
  "backbone",
  "i18n/i18n"
], function (
  Template,
  Templates,
  TemplateRegistry,
  Base,
  DEFAULT_TEMPLATE,
  _,
  api,
  Backbone,
  i18n
) {

  TemplateRegistry.add({
    id: "more",
    name: "editor_more",
    view: Templates.View.extend({}),
    getAdders: function (context) {
      return [{
          name: "client_toolbar_summarize_by_label",
          icon: "../img/summarizeby.png",
          options: {
            template: DEFAULT_TEMPLATE && DEFAULT_TEMPLATE.default
          }
        }
      ]
    },
    create: function (options) {
      var attributes = _.extend(
        {
          "data-template": "summarize",
          "data-enabled": "true",
        }
      );
      return Backbone.View.prototype.make("div", attributes,
        options.template || (options["no-default-template"] === true ? "" : DEFAULT_TEMPLATE && DEFAULT_TEMPLATE.default)
      );
    }
  });

  var Summarize = Template.extend({
    type: "summarize",
    editableName: "client_toolbar_summarize_by_label",
    schema: new Template.Schema({
      attributes: {
        "summarize_by.property": {
          type: "string",
          title: "editor_summarize_by_property",
          values: {
            bind: {
              options: "orderable",
              value: "name",
              text: "localized_name"
            }
          },
        },
        "summarize_by.order_direction": {
          type: "string",
          title: "order_direction",
          values:  [
            { value: "ASCENDING", text: i18n("sort_ascending") },
            { value: "DESCENDING", text: i18n("sort_descending") }
          ],
        },
        "summarize_by.orderby": {
          type: "string",
          title: "client_toolbar_sortingalgorithm_label",
          values: {
            bind: {
              options: "orderable",
              value: "name",
              text: "localized_name"
            }
          },
        },
        "summarize_by.aggregated_properties": {
          type: "keyValue",
          title: "editor_aggregated_properties",
        },
        "summarize_by.summarize_non_existent": {
          title: "editor_summarize_by_non_existent",
          type: "boolean",
          "default": false
        }
      }
    }),

    initialize: function () {
      Template.prototype.initialize.apply(this, arguments);
    },

    getContentSchema: function() {
      return  {
        type: "template"
      };
    },

    getOptions: function (options) {
      options = _.extend(
        {},
        Template.prototype.getOptions.apply(this, arguments),
        this.attributeModel.get()
      );
      return this.schema.parseAttributes(options);
    },

    createSubView: function (node, options, model) {
      var options = _.extend(this.schema.parseAttributes(this.attributeModel.getCamelCase()), options);
      if (options.enabled) {

        var renderView = Template.prototype.createSubView.apply(this, [node, options, model]),
            subView = Template.prototype.createSubView.apply(this, [node, options, model]),
            originalRender = subView.render;

        renderView.el.parentNode.removeChild(renderView.el);

        subView.render = function () {
        var renderedHTML = renderView.el.innerHTML;
          if (renderedHTML !== this.el.innerHTML) {
            this.el.innerHTML = renderedHTML;
          }

          this.$el.find("[data-bind]").each(function () {
            var key = this.getAttribute("data-bind"),
            value = model.get(key.split("."));

            if (/input|select/i.test(this.tagName)) {
              if (/checkbox|radio/i.test(this.type)) {
                this.checked = this.value === value;
              } else {
                this.value = value || this.value;
              }
            }
          });

          return this;
        }

        return subView;
      }
    },

    hasContent: function () { return true; },

});

Summarize.View = Base.extend({

  initialize: function () {
    Base.prototype.initialize.apply(this, arguments);
    this.options['summarize_by.property'] && this.model.set('summarize_by.property', this.options['summarize_by.property']);
    this.options['summarize_by.orderby'] && this.model.set('summarize_by.orderby', this.options['summarize_by.orderby']);
    this.options['summarize_by.order_direction'] && this.model.set('summarize_by.order_direction', this.options['summarize_by.order_direction']);
    this.options['summarize_by.aggregated_properties'] && this.model.set('summarize_by.aggregated_properties', this.options['summarize_by.aggregated_properties']);
    if (this.options['summarize_by.summarize_non_existent']) {
      this.model.set('summarize_by.summarize_non_existent', this.options['summarize_by.summarize_non_existent']);
    } else {
      this.model.unset('summarize_by.summarize_non_existent');
    }

    if (this.options.enabled === "true") {
      this.patchNestedPropertiesOnLoadOutput();
    }
  },

patchNestedPropertiesOnLoadOutput: function() {
  api.search.on("loadoutput", function(model, atts, options) {
    var results = (atts && atts.resultset && atts.resultset.results) || (atts && atts.results);
    if (results) {
        _.each(results, function (result) {
        if (result && result.properties && result.properties["mes:nested"]) {
          var nestedProperties = result.properties["mes:nested"] && result.properties["mes:nested"].data;
          _.each(nestedProperties, function (element, index) {
            _.each(element.properties, function (property) {
              if (property.id === "actions") {
                _.each(property.properties, function (prop) {
                  if (prop.id === "Preview") {
                    var path = ["properties", "mes:nested", "data", index, "properties"];
                    var el = prop.data && prop.data[0] && prop.data[0].html;
                    if (!el) return;
                    var locationPath = '&quot;location_path&quot;:&quot;' + path + '&quot;';
                    if (el.indexOf("content_location") >= 0) {
                      prop.data[0].html = el.replace("&quot;content_location", locationPath + ', &quot;content_location');
                    } else {
                      prop.data[0].html = el.replace("{}", "{" + locationPath + "}");
                    }
                  }
                });
              }
            });
          });
        }
      });
    }
  });
  }
});

Summarize.DEFAULT_TEMPLATE = DEFAULT_TEMPLATE && DEFAULT_TEMPLATE.default;
return Summarize;
});
